import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import { Documentation } from "../models/Documentation";

class DocumentatioService extends GenericCrudService<Documentation> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  getFormData(document: Documentation): FormData {
    const formData = new FormData();
    if (document) {
      if (document.file) {
        formData.append("file", document.file);
      }
    }

    return formData;
  }

  uploadDocument(document: Documentation): Promise<ApiResponse<Documentation>> {
    return HttpClient.post(`${this.path}/upload`, this.getFormData(document), true);
  }
}

export default new DocumentatioService("/ensolvers-ops/documents");
